import type { AssetTimelineEventTypePickerProps } from "./asset-timeline-event-type-picker.type";
import type { ReferentialAssetEventSubtype } from "@/entities/referential/referential-asset-event-types";

import { Select } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useReferentialAssetEventTypes } from "@/entities/referential/referential-asset-event-types";

// TODO DEV-8551 `Option` is deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option } = Select;

export const AssetTimelineEventTypePicker = ({
  onEventTypeChange,
}: AssetTimelineEventTypePickerProps) => {
  const { assetEventTypes, getAssetEventSubTypes } =
    useReferentialAssetEventTypes();
  const [type, setType] = useState<string>();
  const [assetEventSubTypes, setAssetEventSubTypes] =
    useState<ReferentialAssetEventSubtype[]>();
  const { t } = useTranslation();

  // TMP hide "health" type because api is not ready to send events related
  // to "health". Ticket DEV-4558 already exists to put back "health" filter.
  const eventTypes = assetEventTypes?.filter((type) => type.slug !== "health");

  const onTypeChange = (type: string) => {
    setType(type);
    const subtypes = getAssetEventSubTypes(type);
    setAssetEventSubTypes(subtypes);
    onEventTypeChange({ type, subType: undefined });
  };

  return (
    <>
      <Select
        className="asset-timeline-select-type"
        placeholder={t("asset:timeline.filterByType")}
        allowClear
        showSearch={{ optionFilterProp: "children" }}
        onChange={onTypeChange}
      >
        {eventTypes.map((eventType) => (
          <Option key={eventType.slug} value={eventType.slug}>
            {eventType.name}
          </Option>
        ))}
      </Select>
      <Select
        key={type}
        className="asset-timeline-select-subtype"
        placeholder={t("asset:timeline.filterBySubType")}
        allowClear
        showSearch={{ optionFilterProp: "children" }}
        disabled={!type}
        onChange={(subType) => {
          onEventTypeChange({ type, subType });
        }}
      >
        {assetEventSubTypes?.map((eventSubType) => (
          <Option key={eventSubType.slug} value={eventSubType.slug}>
            {eventSubType.name}
          </Option>
        ))}
      </Select>
    </>
  );
};
